<template>
    <label class="input_wrapper">
        <input type="text" :placeholder="placeholder">
    </label>
</template>
<script>
    export default {
        name: 'InputProject',
        props: {
            placeholder: {
                type: String
            }
        }
    }
</script>
<style lang="sass">
    .input_wrapper
        width: 100%
        input
            width: 100%
            height: 36px
            padding: 0 10px
            border-radius: 3px
</style>
